import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { SadtGroupStruct } from 'src/app/shared/services/structs/medical-record/sadt-group.struct';
import { dateHourInCrescentOrderValidator } from 'src/app/shared/custom-validators/date-hour-form-array-order.validator';
import { ObservationScheduling } from 'src/app/shared/services/models/bed/observation-scheduling.model';
import { FrequencyEnum } from 'src/app/shared/enum/medical-record/frequency.enum';
import { KitMultiselectStruct } from 'src/app/shared/services/structs/pharmacy/kit-multiselect.struct';
import { ItemService } from 'src/app/shared/services/API/pharmacy/Item.service';
import { KitService } from 'src/app/shared/services/API/pharmacy/kit.service';
import { ItemModel } from 'src/app/shared/services/models/pharmacy/item.model';
import { StatusSchedulingEnum } from 'src/app/shared/enum/medical-record/status-scheduling.enum';
import { ExamsSuspensionCofirmModalComponent } from '../../exams-suspension-cofirm-modal copy/exams-suspension-cofirm-modal.component';
import { UtilService } from 'src/app/shared/services/util.service';
import { UserRoleEnum } from 'src/app/shared/enum/user-role.enum';

@Component({
    selector: 'app-sadt-scheduling-modal',
    templateUrl: './sadt-scheduling-modal.component.html',
    styleUrls: ['./sadt-scheduling-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SadtSchedulingModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<SadtSchedulingModalComponent>,
    private formBuilder: FormBuilder,
    private maskService: MaskService,
    private alertService: AlertService,
    public itemService: ItemService,
    public kitService: KitService,
    private utilService: UtilService,
  ) { }

  public frequencyEnum: typeof FrequencyEnum = FrequencyEnum;
  public statusSchedulingEnum: typeof StatusSchedulingEnum = StatusSchedulingEnum;
  public userRoleEnum: typeof UserRoleEnum = UserRoleEnum;
  
  public model: FormGroup;
  public masks: Masks;
  
  public listKits: KitMultiselectStruct[] = [];
  public listItems: ItemModel[] = [];

  public sadtGroupStruct: SadtGroupStruct = null;
  public observationScheduling: ObservationScheduling;

  public isLoading: boolean = false;
  public firstLoading: boolean = true;
  public hasActionsButton: boolean = false;
  public buttonToSaveDisabled: boolean = false;
  public userCanSuspended: boolean = true;

  public prescriptionType: number;
  public cycleTime: number;

  public startDateCycle: Date;

  ngOnInit(): void {
    this.firstLoading = false;
    this.userCanSuspended = this.utilService.getRoles().find(x => x.idRole == this.userRoleEnum.therapy_scheduling_nurse_can_suspended) ? true : false;
    this.model = this.formBuilder.group({
      listSchedulingDate: this.formBuilder.array([], { validators: dateHourInCrescentOrderValidator }),
      observation: [""],
      listMaterials: this.formBuilder.array([]),
    });

    this.observationScheduling = this.data.observationScheduling;
    this.cycleTime = this.data.cycleTime;
    this.startDateCycle = this.data.startDateCycle;
    this.prescriptionType = this.data.prescriptionType;

    if(this.data && this.data.prescriptionItem) {
      this.sadtGroupStruct = this.data.prescriptionItem;
    }
    
    this.masks = this.maskService.getMasks();
    this.populate();
  }
  
  submit(){
    //colocar lógica de reaprazamento depois
    const listSchedulingDateForm = this.model.get('listSchedulingDate') as FormArray;

    if(listSchedulingDateForm.errors?.dateLessThanCurrentDate){
      this.alertService.show('Erro', "As datas não podem ser menores que a data de hoje!", AlertType.error);
      return;
    }

    if(this.model.invalid){
      return;
    }

    if (listSchedulingDateForm) {
      
      let inclusionDatePrescription = new Date(this.sadtGroupStruct.datetimeInclusion);
      const firstDateValue = listSchedulingDateForm.at(0).get('date').value.toString();
      const firstHourValue = listSchedulingDateForm.at(0).value.hour.toString();
      if(!this.validFirstDate(firstDateValue, firstHourValue, inclusionDatePrescription)) {
        this.alertService.show('Erro', "Não é possível definir um horário inicial superior às 24h da criação da prescrição!", AlertType.error);
        return;
      }

      let inputDate = this.model.get('listSchedulingDate')['controls'][0].get('date').value;
      let inputHour = this.model.get('listSchedulingDate')['controls'][0].get('hour').value;
      let day = parseInt(inputDate.substring(0, 2), 10);
      let month = parseInt(inputDate.substring(2, 4), 10) - 1; // Mês é base zero
      let year = parseInt(inputDate.substring(4), 10);
      let hour = parseInt(inputHour.substring(0, 2), 10);
      let minute = parseInt(inputHour.substring(2, 4), 10);

      this.sadtGroupStruct.datetimeCheckEstimative =  new Date(year, month, day, hour, minute, 0);
      this.sadtGroupStruct.idStatusScheduling = this.statusSchedulingEnum.Aprazado;
      this.sadtGroupStruct.schedulingObservation = this.model.get('observation').value;
    }
    this.matDialogRef.close({prescription: this.sadtGroupStruct}); 
    
    this.matDialogRef.close();
  }

  populate() {
    let listModelSchedulingDate = (this.model.controls['listSchedulingDate'] as FormArray);
    if(this.sadtGroupStruct.datetimeCheckEstimative) {
      this.sadtGroupStruct.datetimeCheckEstimative = new Date(this.sadtGroupStruct.datetimeCheckEstimative);
      listModelSchedulingDate.push(
        this.createInputDate(this.sadtGroupStruct.datetimeCheckEstimative)
      );
      if(this.sadtGroupStruct.idUserScheduling != null)
        this.buttonToSaveDisabled = true;
      this.model.get('listSchedulingDate').updateValueAndValidity();
      this.model.get('observation').setValue(this.sadtGroupStruct.schedulingObservation);
    } else {
      this.addNextInputDate();
    }
  }

  close(){
    this.matDialogRef.close(); 
  }

  createInputDate(datetimeCheckEstimative?: Date) {
    if (datetimeCheckEstimative != null) {
      return this.formBuilder.group({
        date: [`${(datetimeCheckEstimative.getDate()).toString().padStart(2, '0')}${(datetimeCheckEstimative.getMonth()+1).toString().padStart(2, '0')}${datetimeCheckEstimative.getFullYear()}`, Validators.required],
        hour: [`${(datetimeCheckEstimative.getHours()).toString().padStart(2, '0')}${(datetimeCheckEstimative.getMinutes()).toString().padStart(2, '0')}`, Validators.required],
      });
    }
    else {
      return this.formBuilder.group({
        date: ['', Validators.required],
        hour: ['', Validators.required],
      });
    }
  }
  
  addNextInputDate() {
    (this.model.controls['listSchedulingDate'] as FormArray).push(this.createInputDate());
  }

  removeSchedulingDate(index: number) {
    (this.model.controls['listSchedulingDate'] as FormArray).removeAt(index);
    if (this.model.get('listSchedulingDate')['controls'].length == 0 && index != 0)
      this.addNextInputDate();

  }

  validFirstDate(firstDateValue: string, firstHourValue: string, dateTimeInclusion: Date): boolean {
    const day = parseInt(firstDateValue.substring(0, 2), 10);
    const month = parseInt(firstDateValue.substring(2, 4), 10) - 1; // Mês é base zero
    const year = parseInt(firstDateValue.substring(4), 10);
    const hour = parseInt(firstHourValue.substring(0, 2), 10);
    const minute = parseInt(firstHourValue.substring(2, 4), 10);
    const firstDateInput = new Date(year, month, day, hour, minute, 0);
    dateTimeInclusion.setHours(dateTimeInclusion.getHours()+24)
    if(firstDateInput.getTime() < dateTimeInclusion.getTime())
      return true;
    else 
      return false;
  }

  openExamsSuspensionModal() {
    const dialogRef = this.dialog.open(ExamsSuspensionCofirmModalComponent, {
      data: {
        examToSuspend: this.sadtGroupStruct,
      },
      panelClass: 'prescriptions-suspension-confirm'
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.examToSuspend) {
          this.sadtGroupStruct.motiveSuspended = result.examToSuspend.motiveSuspended;
          this.sadtGroupStruct.idStatus = result.examToSuspend.idStatus;
          this.matDialogRef.close({ prescription: this.sadtGroupStruct });
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

}